// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1iOrt","content":"styles_content__29OXP","checkbox":"styles_checkbox__2KxPw","checkboxLabel":"styles_checkboxLabel__2wRgm"};